// extracted by mini-css-extract-plugin
export default {"labelWithInfo":"YBViQ","divider":"fg0ku","info":"j9yvn"};